import { AxiosClient } from "redux/AxiosClient";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const addMasterSentencesAsync = createAsyncThunk(
  "admin/addMasterSentences",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/addMasterSentences`, payload, toolkit);
  }
);

export const getAllMasterSentencesAsync = createAsyncThunk(
  "admin/getAllMasterSentences",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getAllMasterSentences?page=${payload.page || ""}&limit=${
        payload.limit || ""
      }&search=${payload.search || ""}`,
      [],
      toolkit
    );
  }
);

export const getMasterSentenceByIdAsync = createAsyncThunk(
  "admin/getMasterSentenceById",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getMasterSentenceById/${payload}`,
      [],
      toolkit
    );
  }
);

export const updateMasterSentencesByIdAsync = createAsyncThunk(
  "admin/updateMasterSentencesById",
  async (payload, toolkit) => {
    return await AxiosClient(
      "PUT",
      `/updateMasterSentencesById`,
      payload,
      toolkit
    );
  }
);

export const deleteMasterSentenceAsync = createAsyncThunk(
  "admin/deleteMasterSentence",
  async (payload, toolkit) => {
    return await AxiosClient(
      "DELETE",
      `/deleteMasterSentence/${payload}`,
      [],
      toolkit
    );
  }
);

export const uploadWallOfFameExcelAsync = createAsyncThunk(
  "admin/uploadWallOfFameExcel",
  async (payload, toolkit) => {
    return await AxiosClient(
      "POST",
      `/uploadWallOfFameExcel`,
      payload,
      toolkit
    );
  }
);

export const getAllBulkFilesWallOfFame = createAsyncThunk(
  "admin/getAllBulkFilesWallOfFame",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getAllBulkFiles?page=${payload.page}&limit=${payload.limit}&fileType=${payload?.fileType}`,
      [],
      toolkit
    );
  }
);
